import store from "../../../Store";
import { toggleURLQuery } from "../../../helpers/UrlHelper";
import getDiscounts from "../../../ajax/actions/discount-slab/discount_gets";

export function toggleDiscountListFilter(e) {
  return function (dispatch) {
    let { name, value } = e.target;
    dispatch({ type: "TOGGLE-DISCOUNT-LIST-FILTER", name, value });

    store.dispatch(getDiscounts(true));
  };
}

export function setDefaultDiscountFiltersToURL(history) {
  return (dispatch, getState) => {
    let { discountList } = getState();
    let { data } = discountList;
    let { params } = data;
    Object.keys(params).map((key) => {
      if (
        params[key] !== `` &&
        params[key] !== null &&
        params[key] !== undefined
      ) {
        toggleURLQuery(key, params[key], history);
      }
    });
  };
}

export function resetDiscountParams() {
  return (dispatch) => {
    dispatch({ type: "TOGGLE-RESET-DISCOUNT" });
  };
}
